// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"641b8732","513":"e21ab0e1","703":"04ca544e","787":"c3ee2ac3"}[chunkId] + ".chunk.js";
};